import React from 'react';
import { FiSearch } from 'react-icons/fi';

export const GlassSearchInput = ({ placeholder, onChange }) => {
  return (
    <div className="relative">
      <input
        type="text"
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        className="pl-10 pr-4 py-2 w-[22vw] bg-white/20 backdrop-blur-md text-sm rounded-xl shadow-inner placeholder-gray-300 focus:outline-none focus:ring-1 focus:ring-white/30 text-white"
      />
      <span className="absolute inset-y-0 left-3 flex items-center text-white/70">
        <FiSearch size={16} />
      </span>
    </div>
  );
};
